module.exports = "<div class=\"title\">\n  <h2>{{group.title}}</h2>\n</div>\n<div class=\"content\">\n  <app-image *ngFor=\"let image of group.images\" [image]=\"image\" (click)=\"selectImage(image)\"></app-image>\n  <div class=\"upload-area\" (click)=\"modal.show($event, group)\">\n    <span>+</span>\n  </div>\n</div>\n<app-image-preview *ngIf=\"selectedImage\" (close)=\"selectImage(null)\" [image]=\"selectedImage\"></app-image-preview>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/group/group.component.html
// module id = 220
// module chunks = 1